import React, { useState } from "react";
import styled from "@emotion/styled";
import 'react-csv-importer/dist/index.css';
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from "@mui/icons-material/Error";
import { useTheme } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import AssigneeDropdown from "../../../../DropDowns/AssigneeDropdown";
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { StyledToggleButton } from "../../../../../componentThemes";
import { selectOpenLeadInvestigationPerm } from "../../../../../slices/userActionsPermissionsSlice";
import { useSetStatusInvestigatingMutation } from "../../../../../slices/api/apiSlice";
import { selectTeamDefaultInterestRate, selectTeamDefaultTargetTerm } from "../../../../../slices/teamAndUserSettingsSlice";
import { Button } from "../../../../../StyledComponents";
import { setLeadActionNavMenuSelection } from "../../../../../slices/sessionDataSlice";
import WorkflowPanel, { DecisionCard, DecisionCopy, DecisionTitle, FieldCard, WorkflowBody, WorkflowFooter, WorkflowHeader, WorkflowScroll } from "./WorkflowPanel";

const InvestigateLead = ({ handleCloseModal, userId, teamId, userFullName, teamMembersByName, mortgageId, leadData, dashPerspective, requestOrigin }) => {
  const theme = useTheme()
  const dispatch = useDispatch()

  const defaultTargetLoanTerm = useSelector(selectTeamDefaultTargetTerm)
  const defaultTargetInterestRate = useSelector(selectTeamDefaultInterestRate)
  const openLeadInvestigationPerm = useSelector(selectOpenLeadInvestigationPerm)

  const [assigneeIds, setAssigneeIds] = useState(leadData.assigneeIds)
  const [targetOutcome, setTargetOutcome] = useState('renegotiation')
  const [isError, setIsError] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleSetAssignee = (event) => {
    setAssigneeIds(event.target.value)
  };

  const [setStatusInvestigating] = useSetStatusInvestigatingMutation()
  
  let handleSetInvestigating = async () => {
    setIsLoading(true)
    let assigneeNames = []
    for (let i = 0; i < assigneeIds.length; i++) {
      let teamMember = teamMembersByName.find(selected => selected.memberId === assigneeIds[i])
      assigneeNames.push(teamMember.fullName)
    }
    let resp = await setStatusInvestigating({
      userId: userId,
      mortgageId: mortgageId,
      userFullName: userFullName,
      assigneeNames: assigneeNames,
      leadId: leadData._id,
      assigneeIds: assigneeIds,
      targetOutcome: targetOutcome,
      teamId: teamId,
      defaultTargetLoanTerm: defaultTargetLoanTerm,
      defaultTargetInterestRate: defaultTargetInterestRate,
      existingTargetInterestRate: leadData.targetInterestRate,
      requestOrigin: requestOrigin,
    })
    if (resp.error) {
      setIsError(true)
    } else if (resp.data.message.includes('success')) {
      setIsSuccess(true)
    } else {
      setIsError(true)
    }
    setIsLoading(false)
  }

  const handleTargetOutcome = (event) => {
    setTargetOutcome(event.target.value)
  }
  const handleGoToClosing = () => {
    dispatch( setLeadActionNavMenuSelection('beginClosingLead'))
  }

  return (
    <WorkflowPanel>
      {isSuccess ?
        <WorkflowHeader tone="success" title="Success" icon={<CheckIcon />} />
      : isError ?
        <WorkflowHeader tone="error" title="Failed... please try again. Reach out to support@lancastersweep.com if the problem persists." icon={<ErrorIcon />} />
      :
        <WorkflowHeader title="Open Investigation" subtitle="Set the investigation path and ownership." />
      }

      <WorkflowBody>
        <WorkflowScroll className={isSuccess ? "centered" : ""}>
          {isSuccess ?
            <DecisionCard>
              <DecisionTitle>Investigation opened</DecisionTitle>
              <DecisionCopy>
                {targetOutcome === "renegotiation" ?
                  `Renegotiating this mortgage is now under investigation.`
                :
                  `Refinancing this mortgage is now under investigation.`
                }
              </DecisionCopy>
            </DecisionCard>
          :
            <>
              <DecisionCard>
                <DecisionTitle>Prepare investigation</DecisionTitle>
                <DecisionCopy>Select the target outcome and assign one or more team members to the investigation.</DecisionCopy>
              </DecisionCard>
              <FieldCard>
                <FieldTitle>Target Outcome</FieldTitle>
                <ToggleButtonGroup
                  value={targetOutcome}
                  exclusive
                  onChange={handleTargetOutcome}
                >
                  <StyledToggleButton value="renegotiation">
                    RENEGOTIATION
                  </StyledToggleButton>
                  <StyledToggleButton value="refinance">
                    REFINANCE
                  </StyledToggleButton>
                </ToggleButtonGroup>
              </FieldCard>
              <FieldCard>
                <FieldTitle>Assignee(s)</FieldTitle>
                <AssigneeDropdown
                  value={assigneeIds}
                  handleChange={handleSetAssignee}
                  items={teamMembersByName}
                />
              </FieldCard>
            </>
          }
        </WorkflowScroll>
        <WorkflowFooter>
          {isSuccess || isError ?
            <>
              <Button className="neutral" onClick={() => handleCloseModal()}>close</Button>
              <Button className="primary" onClick={() => handleGoToClosing()} style={{width: '15rem'}}>go to Closing</Button>
            </>
          :
            <Button
              className={!openLeadInvestigationPerm ? "primaryDisabled" : isLoading ? "primaryLoading" : "primary"} 
              onClick={openLeadInvestigationPerm ? () => handleSetInvestigating() : null} 
            >
              {isLoading ?
                <CircularProgress
                  sx={{ color: `${theme.palette.common.white}` }}
                  size={18}
                />
              :
                `Confirm`
              }
            </Button>
          }
        </WorkflowFooter>
      </WorkflowBody>
    </WorkflowPanel>
  )
}

const FieldTitle = styled.div(({ theme }) => `
  color: ${theme.palette.common.black};
  font-size: 0.95rem;
  font-weight: 800;
`)

export default InvestigateLead;
